export const COMMENT_SECTION_CLAMP_LINES = 2;
export const COMMENT_SECTION_OVERFLOW_TOLERANCE_PX = 3;
/** Chars per line rough estimate for jsdom, where layout metrics are unavailable. */
export const COMMENT_SECTION_CHARS_PER_LINE = 42;

export function commentSectionBodyOverflows(
  element: HTMLElement,
  renderedText: string,
): boolean {
  // Prefer real layout: line-clamp hides overflow when scrollHeight exceeds
  // clientHeight. Width-sensitive — re-measured via ResizeObserver when the
  // comment panel is resized.
  if (element.clientHeight > 0) {
    return (
      element.scrollHeight >
      element.clientHeight + COMMENT_SECTION_OVERFLOW_TOLERANCE_PX
    );
  }
  // jsdom / pre-layout fallback only — never used once the element has height.
  return (
    renderedText.length >
    COMMENT_SECTION_CLAMP_LINES * COMMENT_SECTION_CHARS_PER_LINE
  );
}
